import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconArrowRight: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: true,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.0546 20C9.85464 20 9.55464 19.9001 9.35464 19.8C8.95464 19.4001 8.85464 18.8 9.25464 18.4L14.7546 12.0001L9.25464 5.70005C8.85464 5.30005 8.95464 4.60005 9.35464 4.30005C9.75464 3.90005 10.4546 4.00005 10.7546 4.40005L16.7546 11.4001C17.0546 11.8001 17.0546 12.3 16.7546 12.7L10.7546 19.7C10.6546 19.9 10.3546 20 10.0546 20Z',
    })
  )
}
